import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-858f674a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card text-center" }
const _hoisted_2 = {
  key: 0,
  class: "card-body minheight d-flex justify-content-center align-items-center"
}
const _hoisted_3 = { class: "text-center p-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "mt-2 d-block" }
const _hoisted_6 = {
  key: 1,
  class: "card-body"
}
const _hoisted_7 = { class: "dash-comp" }
const _hoisted_8 = { class: "dash-comp" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "curr" }
const _hoisted_11 = { class: "number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fa', 'fa-spinner'],
              class: "fs-1"
            }),
            _hoisted_4,
            _createElementVNode("strong", _hoisted_5, _toDisplayString(_ctx.labelText), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("h6", _hoisted_7, [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.allCss)
            }, null, 2)
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.labelText), 1),
          _createElementVNode("h3", _hoisted_8, [
            (_ctx.hasCurrency)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.currencyLabel), 1),
                  _createTextVNode(" ")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.appFxs.formatNbrShorten(_ctx.dashBData.TotalRevenuesCurrent)), 1)
          ]),
          _createElementVNode("small", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.dashBData.TotalRevenuesGrowth)) + "%", 1),
            _createTextVNode("  " + _toDisplayString(_ctx.growthTotalRevenuesLabel.toLocaleLowerCase()), 1)
          ])
        ]))
  ]))
}